module.exports = __webpack_public_path__ + "img/zh-CN.52582e4d.svg";